import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$columns, _vm$columns2;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": _vm.items.length || !_vm.isConfiguring ? "100%" : 950
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Reconciliation")])]), _c(VCardText, [!_vm.items.length && _vm.isConfiguring ? _c(VForm, {
    ref: "form",
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      clearable: "",
      disabled: _vm.warehouses.length === 0 || _vm.isUploading,
      items: _vm.warehouses,
      "item-text": "name",
      "item-value": "id_warehouse",
      placeholder: "Select a warehouse",
      label: "Warehouse",
      rules: [_vm.rules.mustSelectValue],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.warehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "warehouseId", $$v);
      },
      expression: "form.warehouseId"
    }
  }), _c("UploaderV2", {
    ref: "uploader",
    attrs: {
      url: _vm.uploadUrl,
      fileTypes: [".xlsx", ".xlsm"],
      multiple: false,
      hideUploadButton: ""
    },
    on: {
      sync: _vm.syncFiles,
      "click:upload": _vm.acknowledgeUpload,
      "upload:failed": _vm.uploadFailed
    }
  }), !((_vm$columns = _vm.columns) !== null && _vm$columns !== void 0 && _vm$columns.length) > 0 ? _c("div", {
    staticClass: "mt-default"
  }, [_c("span", {
    staticClass: "errorLabel"
  }, [_vm._v("Upload a file to define the mapping between columns")])]) : _vm.columns.length ? _c("div", {
    staticClass: "column-chooser"
  }, [_c("div", [_c("span", {
    staticClass: "column-chooser-header"
  }, [_vm._v("SKU column")]), _c(VRadioGroup, {
    attrs: {
      rules: [_vm.rules.mustSelectValue]
    },
    model: {
      value: _vm.form.sku,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sku", $$v);
      },
      expression: "form.sku"
    }
  }, _vm._l(_vm.columns, function (n) {
    return _c(VRadio, {
      key: n,
      attrs: {
        disabled: _vm.isUploading,
        label: n,
        value: n
      }
    });
  }), 1)], 1), _c("div", [_c("span", {
    staticClass: "column-chooser-header"
  }, [_vm._v(" Quantity in warehouse column "), _c("br"), _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("(available + committed)")])]), _c(VRadioGroup, {
    attrs: {
      rules: [_vm.rules.mustSelectValue]
    },
    model: {
      value: _vm.form.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "quantity", $$v);
      },
      expression: "form.quantity"
    }
  }, _vm._l(_vm.columns, function (n) {
    return _c(VRadio, {
      key: n,
      attrs: {
        disabled: _vm.isUploading,
        label: n,
        value: n
      }
    });
  }), 1)], 1), _c("div", [_c("span", {
    staticClass: "column-chooser-header"
  }, [_vm._v("Product designation column")]), _c(VRadioGroup, {
    attrs: {
      rules: [_vm.rules.mustSelectValue]
    },
    model: {
      value: _vm.form.label,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "label", $$v);
      },
      expression: "form.label"
    }
  }, _vm._l(_vm.columns, function (n) {
    return _c(VRadio, {
      key: n,
      attrs: {
        disabled: _vm.isUploading,
        label: n,
        value: n
      }
    });
  }), 1)], 1)]) : _vm._e(), _c("div", {
    staticClass: "text-right"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small mt-4",
    attrs: {
      loading: _vm.isUploading,
      rounded: "",
      disabled: this.$refs.uploader && !this.$refs.uploader.$data.files.length || !((_vm$columns2 = _vm.columns) !== null && _vm$columns2 !== void 0 && _vm$columns2.length) > 0 || !_vm.form.sku || !_vm.form.quantity || !_vm.form.label
    },
    on: {
      click: _vm.submit
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-upload mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Submit file ")], 1)], 1)], 1) : [_c("div", {
    staticStyle: {
      "margin-top": "-0.5rem",
      "margin-bottom": "-0.85rem"
    }
  }, [_vm._v(" Warehouse : " + _vm._s(_vm.warehouses.find(function (x) {
    return x.id_warehouse == _vm.form.warehouseId;
  }).name) + " ")]), _c("div", {
    staticClass: "action-bar"
  }, [_c(VChipGroup, {
    attrs: {
      multiple: "",
      "active-class": "chip--active"
    }
  }, _vm._l([{
    text: "Quantities discrepancies",
    value: "quantities"
  }, {
    text: "Sku missing in warehouse's file",
    value: "file"
  }, {
    text: "Sku missing in plateform's inventory",
    value: "inventory"
  }], function (tag) {
    return _c(VChip, {
      key: tag.value,
      on: {
        click: function click($event) {
          return _vm.handleClickTag(tag.value);
        }
      }
    }, [_vm._v(" " + _vm._s(tag.text) + " ")]);
  }), 1), _c(VTextField, {
    attrs: {
      clearable: "",
      label: "Filter results",
      "search-input": _vm.handleSearch
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.handleSearch = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.handleSearch = $event;
      },
      input: _vm.handleSearch
    }
  })], 1), _c(VDataTable, {
    staticClass: "elevation-2 --tds-vertical-align-top",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.items,
      "loading-text": "Loading... Please wait",
      "item-class": function itemClass(item) {
        return item.verified ? "teal-row" : "";
      }
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("svg", {
          staticClass: "icon icon-xxs dot",
          class: ["fill-".concat(item.status)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })])];
      }
    }, {
      key: "item.fileQuantity",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [isNaN(item.fileQuantity) ? _c("span", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")]) : _c("span", [_vm._v(" " + _vm._s(item.fileQuantity) + " ")])];
      }
    }, {
      key: "item.adjustment",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [!item.isMissingInStock ? _vm._l(item.stocks, function (stock, i) {
          var _stock$countries;
          return _c("div", {
            key: "adjustStock-" + stock.id_stock
          }, [_c("div", {
            class: ["text-left", i > 0 ? "border-top-grey mt-2 pt-1" : ""]
          }, [_c("div", {
            staticClass: "text-bold"
          }, [_vm._v(" " + _vm._s(stock.quantity + stock.quantity_committed) + " btl(s) "), _c("router-link", {
            staticClass: "router-link text-normal text-smaller ml-1",
            attrs: {
              to: _vm.goToStock(stock.id_stock),
              target: "_blank"
            }
          }, [_c(VIcon, {
            staticClass: "fas fa-external-link-alt",
            staticStyle: {
              top: "-1px"
            },
            attrs: {
              size: "0.65rem"
            }
          }), _vm._v(" Stock details ")], 1)], 1), _c("div", {
            staticClass: "text-smaller text-italic line-height-1_1"
          }, [_vm._v(" " + _vm._s(stock.reservationLabel ? "Res: " + stock.reservationLabel + ", " : "") + " for " + _vm._s(((_stock$countries = stock.countries) === null || _stock$countries === void 0 ? void 0 : _stock$countries.length) > 3 ? stock.countries.length + " countries" : stock.countries.map(function (x) {
            return x.name;
          }).join(", ")) + " ")])]), _c("div", {
            staticClass: "cell-quantity"
          }, [_c("MinusPlusInput", {
            attrs: {
              min: -Math.abs(stock.quantity + stock.quantity_committed),
              max: item.deltaQuantity + 1000
            },
            on: {
              input: function input($event) {
                return _vm.reRenderItem(item);
              }
            },
            model: {
              value: stock.adjustmentQuantity,
              callback: function callback($$v) {
                _vm.$set(stock, "adjustmentQuantity", $$v);
              },
              expression: "stock.adjustmentQuantity"
            }
          }), _c(VBtn, {
            staticClass: "dfwa-btn --small secondary",
            attrs: {
              "x-small": "",
              rounded: "",
              loading: _vm.isSavingQuantity[stock.id_stock],
              disabled: stock.adjustmentQuantity === 0
            },
            on: {
              click: function click($event) {
                $event.stopPropagation();
                return _vm.saveQuantity(stock, item);
              }
            }
          }, [_vm._v(" Apply ")])], 1), _vm.saveQuantityErrorMessage[stock.id_stock] ? _c("div", {
            staticClass: "error-message text-left mb-2 errorLabel"
          }, [_vm._v(" " + _vm._s(_vm.saveQuantityErrorMessage[stock.id_stock]) + " ")]) : _vm._e()]);
        }) : [!item.isMissingWine ? _c("div", [_c(VBtn, {
          staticClass: "dfwa-btn --small-2",
          attrs: {
            rounded: "",
            to: _vm.goToCreateStock(item),
            target: "_blank"
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-plus mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" New stock without PO ")], 1)], 1) : _c("div", {
          staticClass: "text-smaller"
        }, [_c("div", [_vm._v(" The product associated was not automatically found. You should verify that the product does not already exists, create it if not, and create the associated stock. ")]), _c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.goToProductList(item.sku),
            target: "_blank"
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-external-link-alt",
          staticStyle: {
            top: "-1px"
          },
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Product list ")], 1)], 1)]];
      }
    }, {
      key: "item.verified",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c(VCheckbox, {
          attrs: {
            "hide-details": "auto"
          },
          on: {
            click: function click($event) {
              return _vm.reRenderItem(item);
            }
          },
          model: {
            value: item.verified,
            callback: function callback($$v) {
              _vm.$set(item, "verified", $$v);
            },
            expression: "item.verified"
          }
        })];
      }
    }])
  }), _c("div", {
    staticClass: "text-right"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small mt-4",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.startOver
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-sync mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Restart ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary mt-4",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.exportAs("csv");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-download mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Export as CSV ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary mt-4",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.exportAs("xlsx");
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-download mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Export as XLSX ")], 1)], 1)]], 2), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };